"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePolicyScheduleForms = void 0;
require("../models");
const useDailyScheduleForm_1 = require("./useDailyScheduleForm");
const useHealthCheckForm_1 = require("./useHealthCheckForm");
const useMonthlyScheduleForm_1 = require("./useMonthlyScheduleForm");
const useWeeklyScheduleForm_1 = require("./useWeeklyScheduleForm");
const useYearlyScheduleForm_1 = require("./useYearlyScheduleForm");
const usePolicyScheduleForms = (dailyScheduleModel, weeklyScheduleModel, monthlyScheduleModel, yearlyScheduleModel, healthCheckModel) => {
    const dailyScheduleForm = useDailyScheduleForm_1.useDailyScheduleForm(dailyScheduleModel);
    const weeklyScheduleForm = useWeeklyScheduleForm_1.useWeeklyScheduleForm(weeklyScheduleModel);
    const monthlyScheduleForm = useMonthlyScheduleForm_1.useMonthlyScheduleForm(monthlyScheduleModel);
    const yearlyScheduleForm = useYearlyScheduleForm_1.useYearlyScheduleForm(yearlyScheduleModel);
    const healthCheckForm = useHealthCheckForm_1.useHealthCheckForm(healthCheckModel, dailyScheduleModel, weeklyScheduleModel, monthlyScheduleModel, yearlyScheduleModel);
    return {
        dailyScheduleForm,
        weeklyScheduleForm,
        monthlyScheduleForm,
        yearlyScheduleForm,
        healthCheckForm,
    };
};
exports.usePolicyScheduleForms = usePolicyScheduleForms;
//# sourceMappingURL=usePolicyScheduleForms.js.map